import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';

@Component({
  selector: 'app-modal-planning-hq-audit-detail',
  templateUrl: './modal-planning-hq-audit-detail.component.html',
  styles: []
})
export class ModalPlanningHqAuditDetailComponent extends ExcTranslation implements OnInit {

  Data = {};
  docOptions = [
    {value: 1, text: this.getGlobal('No'), selected: false},
    {value: 21, text: this.getGlobal('Yes'), selected: false}
  ];
  uaOptions = [
    {value: 'No', text: this.getGlobal('No'), selected: false},
    {value: 'Yes', text: this.getGlobal('Yes'), selected: false}
  ];
  setDoc(e) {
    this.Data['Auftr_Brief'] = e;
  }
  setUa(e) {
    this.Data['auftr_ua'] = e;
  }
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
  }

  ngOnInit() {
    this.Data = {};
    Object.assign(this.Data, this.overlayConfig.data);
    this.Data['ua'] = this.Data['auftr_ua'] === 1 ? 'No' :  'Yes';
  }
  proceed() {
    this.Data['auftr_ua'] = this.Data['ua'] === 'No' ? 1 : 0;
    this.overlayRef.close({proceed: true, data: this.Data});
  }
  hasChanges() {
    for (const k of Object.keys(this.overlayConfig.data)) {
      if (this.Data[k] !== this.overlayConfig.data[k]) {
        return true;
      }
    }
    return false;
  }
  getAudittype() {
    if (this.Data['auftr_art'] === 16) {
      return 'Selfcheck';
    } else {
      return 'Floorcheck (' + this.getGlobal('AuditType_' + this.Data['auftr_art']) + ')';
    }
  }
}
